export default __webpack_public_path__ + "static/media/shuttle.237f80dd.gif";